import React from "react";
import { useWatchState } from "@/store";
import { Upload } from "@/components";
import { BaseService, uploadUrl } from "@/service";
import { Modal, Button, Popconfirm } from "antd";
import "./style.less";

const getSize = b => {
    if (b < 1024) return b + "b"
    if (b > 1024 && b < 1048576) return parseInt(b / 1024) + "kb"
    if (b > 1048576) return parseInt(b / 1048576) + "m"
}

const App = () => {

    const [[props, setProps]] = useWatchState(["modal.files"])
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const { title, show, hide, width = 600, files = [], upload = false, type, itemId } = props;

    const onRemoveFile = id => {
        BaseService.del({
            table: "thtt_attachment_relation",
            where: { id }
        }).then(res => {
            refeshFile();
        })
    }

    const onUploadFileFinish = (e) => {
        const size = e.file.size;
        const add_time = new Date().format("yyyy-MM-dd hh:mm:ss");
        const newFiles = e.file.response.files.map(({ fileShowName, suffix, url }) => ({ type, item_id: itemId, file_name: fileShowName, file_path: url, file_suffix: suffix, size, add_time }));
        BaseService.adds({
            table: "thtt_attachment_relation",
            data: newFiles
        }).then(res => {
            refeshFile();
        })
    }

    const refeshFile = async () => {
        const fileRes = await BaseService.list({
            table: "thtt_attachment_relation",
            where: { item_id: itemId, type, is_delete: 0 },
        })
        const files = fileRes.data.result;
        props.files = files.map(({ id, file_name, size, add_time, file_path }) => ({ id, title: file_name, href: `http://${UPLOAD_SERVER_HOST}${file_path}`, size, addTime: new Date(add_time).format("yyyy-MM-dd hh:mm:ss") }));
        setProps({ ...props });
    }

    return (
        <Modal
            className="modal-files"
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div>
                <div className="flex between">
                    <span></span>
                    {upload && (
                        <Upload
                            name="files"
                            onFinish={onUploadFileFinish}
                            action={uploadUrl}
                            showUploadList={false}
                        >
                            <Button>上传</Button>
                        </Upload>
                    )}
                </div>
                <table className="full">
                    <thead>
                        <tr>
                            <th>名称</th>
                            <th>大小</th>
                            <th>上传时间</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        {files.map(({ id, title, addTime, size, href }) => (
                            <tr>
                                <td>{title}</td>
                                <td>{getSize(size)}</td>
                                <td>{addTime}</td>
                                <td className="flex ver child-left-sm">
                                    <Popconfirm
                                        title="确认要删除此文件吗？"
                                        onConfirm={onRemoveFile.later(id)}
                                        okText="确认"
                                        cancelText="取消"
                                    >
                                        <p className="link">删除</p>
                                    </Popconfirm>
                                    <a href={href} target="_blank" rel="noopener noreferrer">下载</a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* <Wave width={width} height={50} bgColor="transparent" style={{ position: "absolute", bottom: 0, left: 0 }} /> */}
            </div>
        </Modal>
    );
}

export default App;